import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles(() => ({
  loadingContainer: {
    width: '100%',
    textAlign: 'center'
  }
}))


const LoadingMenu = () => {
  const classes = useStyles()

  return <Grid
    className={classes.loadingContainer}
    container
    justify="center"
    direction="row"
    alignContent="center"
    alignItems="center"
  >
    <Grid item xs={12}>
      <h1>Carregando...</h1>
    </Grid>
    <Grid item xs={12}>
      <CircularProgress size={200} color="inherit"/>
    </Grid>
  </Grid>
}

export default LoadingMenu
